export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7f04ab55c57375349e064a791890fad8cde34125a4&name=apiMindbox!'